<template>
  <div class="overflow-x-hidden">
  <!-- HERO and TOP SECTIONS from index.html -->
  <header class="grid override grid-cols-1">
    <div data-hero-parallax-container class="z-[6] relative flex items-center justify-center border-b border-black animated-gradient px-0 md:px-8 py-40 lg:px-[8vw] md:py-[12rem] z-[1]">
      <div class="flex flex-col max-w-screen-lg items-center gap-6 text-center z-10 text-dark-teal-600">
          <h1 class="leading-none text-6xl md:text-7xl lg:text-8xl font-medium">
            <Typewriter :words="heroTypewriterWords" :typingSpeed="230" :deletingSpeed="80" :delay="6000" />
            <br class="sm:hidden">
            <span class="whitespace-nowrap">&nbsp;{{ t('pages.index.hero.titleSuffix') }}</span>
          </h1>
          <div class="text-xl max-w-md lg:text-2xl lg:max-w-3xl">
            {{ heroTagline.line1 }}<br />
            {{ heroTagline.line2 }}
          </div>
        <div class="mt-2 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full max-w-[384px] sm:max-w-none sm:w-auto mx-auto">
          <div class="w-full sm:w-auto [&>div]:!block">
            <div class="relative inline-block group">
              <div class="absolute inset-0 rounded bg-yellow-500 border border-black transition-transform duration-150 group-hover:-translate-x-4 z-20"></div>
              <div class="absolute inset-0 rounded bg-yellow-200 border border-black transition-transform duration-150 group-hover:-translate-x-6 group-hover:translate-y-2 z-10"></div>
              <NuxtLink class="relative inline-flex rounded no-underline items-center justify-center border border-black transition-all duration-150 group-hover:-translate-x-2 group-hover:-translate-y-2 z-30 w-full lg:w-auto h-14 px-8 text-xl lg:h-16 lg:px-10 lg:text-xl bg-dark-teal-600 text-white" :to="localePath('join')">
                {{ t('pages.index.hero.ctaPrimary') }}
              </NuxtLink>
            </div>
          </div>
          <form action="/collection" method="get" class="relative w-full sm:w-auto">
            <label for="marketplace-search" class="sr-only">{{ t('pages.index.hero.searchLabel') }}</label>
            <input
              id="marketplace-search"
              type="text"
              name="query"
              :placeholder="t('pages.index.hero.searchPlaceholder')"
              class="bg-white px-4 pr-12 border border-marian-blue rounded focus:outline-none focus:ring-1 focus:ring-marian-blue focus:border-marian-blue w-full sm:w-64 !text-xl !h-14 lg:!h-16"
            />
            <button
              type="submit"
              :aria-label="t('pages.index.hero.searchAriaLabel')"
              class="absolute mr-3 right-0 top-1/2 -translate-y-[55%]"
            >
              <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
            </button>
          </form>
        </div>
        <!-- <div class="text-base text-gray-600 text-muted">
          Contribute or fork on <a href="https://github.com/antiwork/gumroad" target="_blank" rel="noopener noreferrer" class="underline hover:text-black inline-flex items-center gap-1 ml-1">
            <svg class="w-4 h-4" viewBox="0 0 16 16" fill="currentColor">
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
            </svg>
            GitHub
          </a>
        </div> -->
      </div>
      <div class="absolute inset-0 pointer-events-none overflow-visible parallax-up">
        <ParallaxCoin
            src="/images/broken-diamond.svg"
          alt="Decorative coin 1"
            className="-rotate-20 w-[8rem] invisible md:visible sm:w-[8rem] sm:top-[24rem] sm:right-[-3rem] md:w-[10rem] md:top-[48rem] md:right-[15rem] lg:w-[12rem] lg:top-[45rem] opacity-80"
          :scrollIntensity="-0.20"
          :mouseIntensity="0.03"
        />
        <ParallaxCoin
            src="/images/broken-diamond.svg"
          alt="Decorative coin 2"
            className="rotate-20 w-[10rem] top-[24rem] left-[-12vw] sm:left-[-7vw] md:left-[3vw] md:w-[11rem] md:top-[22rem] md:left-[8vw] opacity-90"
          :scrollIntensity="-0.15"
          :mouseIntensity="-0.02"
        />
        <ParallaxCoin
            src="/images/broken-diamond.svg"
          alt="Decorative coin 3"
            className="-rotate-10 w-[9rem] right-[-3vw] top-[-7rem] invisible sm:visible md:w-[8rem] md:top-[24rem] md:right-[6vw] opacity-70"
          :scrollIntensity="-0.18"
          :mouseIntensity="0.05"
        />
        <ParallaxCoin
            src="/images/broken-diamond.svg"
          alt="Decorative Coin 4"
            className="w-[9rem] top-[41rem] right-[-14vw] sm:top-[36rem] sm:right-[-5rem] md:w-[11rem] md:top-[34rem] md:right-[-5rem] lg:w-[12rem] lg:top-[36rem] lg:right-[-4rem] opacity-80"
          :scrollIntensity="-0.16"
          :mouseIntensity="-0.035"
        />
        <ParallaxCoin
            src="/images/broken-diamond.svg"
          alt="Decorative Coin 5"
            className="w-[10rem] left-[-2rem] top-[46rem] sm:w-[10rem] sm:top-[38rem] sm:left-[3rem] md:w-[14rem] md:top-[35rem] md:left-[-6rem] lg:w-[16rem] lg:left-[-3rem] blur-sm opacity-100"
          :scrollIntensity="-0.17"
          :mouseIntensity="0.04"
        />
      </div>
    </div>
  </header>
  <div class="z-[1] bg-white relative py-24 lg:border-b lg:border-black lg:py-32 text-dark-teal-600">
    <div class="px-8 lg:px-[4vw]">
      <div class="max-w-4xl mx-auto text-center text-4xl mb-20 lg:mb-24 lg:leading-tight lg:text-6xl lg:font-medium">
          {{ t('pages.index.intro.title') }}
      </div>
    </div>
    <div class="relative max-w-6xl mx-auto mb-12 h-80 bg-light-brown-200 p-8 border-y border-black lg:border lg:rounded-full">
        <div id="lottie-animation" class="absolute w-56 h-56 z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 lg:top-40 lg:w-70 lg:h-70">
        <lottie-player
            src="/animations/gears.json"
            speed="0.2"
          loop
          autoplay>
        </lottie-player>
      </div>
      <div class="relative flex h-full flex-col justify-between rounded-2xl border border-black bg-light-brown-200 z-10 lg:px-8 lg:rounded-full">
        <div class="override hidden px-4 flex justify-between -mt-3 lg:flex lg:px-40">
          <div class="flex h-6 items-center bg-light-brown-200 pr-6 lg:gap-x-10">
            <img alt="Right arrow" class="h-6 w-6 -translate-x-3" src="/images/icons/arrowhead-right.svg" />
            <div class="lg:text-2xl">{{ t('pages.index.intro.steps.publish') }}</div>
          </div>
          <div class="flex h-6 items-center bg-light-brown-200 pr-6 lg:gap-x-10">
            <img alt="Right arrow" class="h-6 w-6 -translate-x-3" src="/images/icons/arrowhead-right.svg" />
            <div class="lg:text-2xl">{{ t('pages.index.intro.steps.story') }}</div>
          </div>
        </div>
        <div class="override hidden px-4 flex justify-between -mb-3 lg:flex lg:px-40">
          <div class="flex h-6 items-center bg-light-brown-200 pl-6 lg:gap-x-10">
            <div class="lg:text-2xl">{{ t('pages.index.intro.steps.sendHome') }}</div>
            <img alt="Left arrow" class="h-6 w-6 translate-x-3 rotate-180" src="/images/icons/arrowhead-right.svg" />
          </div>
          <div class="flex h-6 items-center bg-light-brown-200 pl-6 lg:gap-x-10">
              <div class="lg:text-2xl">{{ t('pages.index.intro.steps.findOwner') }}</div>
            <img alt="Left arrow" class="h-6 w-6 translate-x-3 rotate-180" src="/images/icons/arrowhead-right.svg" />
          </div>
        </div>
        <div class="override flex h-6 items-center bg-light-brown-200 absolute top-0 -ml-2 pr-3 -mt-3 left-1/2 -translate-x-1/2 lg:hidden">
          <img alt="Right arrow" class="h-4 w-4 -translate-x-2 -translate-y-px" src="/images/icons/arrowhead-right.svg" />
            <div class="whitespace-nowrap lg:text-2xl">{{ t('pages.index.intro.steps.publish') }}</div>
        </div>
        <div class="override flex h-6 items-center bg-light-brown-200 absolute right-0 pr-3 origin-center rotate-90 top-1/2 -translate-y-1/2 translate-x-1/2 lg:hidden">
          <img alt="Right arrow" class="h-4 w-4 -translate-x-2 -translate-y-px" src="/images/icons/arrowhead-right.svg" />
            <div class="whitespace-nowrap lg:text-2xl">{{ t('pages.index.intro.steps.story') }}</div>
        </div>
        <div class="override flex h-6 items-center bg-light-brown-200 absolute bottom-0 -ml-2 pl-3 -mb-3 left-1/2 -translate-x-1/2 lg:hidden">
            <div class="whitespace-nowrap lg:text-2xl">{{ t('pages.index.intro.steps.findOwner') }}</div>
          <img alt="Left arrow" class="h-4 w-4 translate-x-2 translate-y-px rotate-180" src="/images/icons/arrowhead-right.svg" />
        </div>
        <div class="override flex h-6 items-center bg-light-brown-200 absolute left-0 pr-3 origin-center -rotate-90 top-1/2 -translate-y-1/2 -translate-x-1/2 lg:hidden">
          <img alt="Right arrow" class="h-4 w-4 -translate-x-2 -translate-y-px" src="/images/icons/arrowhead-right.svg" />
            <div class="whitespace-nowrap lg:text-2xl">{{ t('pages.index.intro.steps.sendHome') }}</div>
        </div>
      </div>
    </div>
    <div class="max-w-4xl mx-auto text-center flex flex-col gap-4 px-8 mt-48">
      <h2 class="z-10 text-4xl lg:text-5xl lg:leading-tight bg-white text-dark-teal-600">
          {{ t('pages.index.belief.title') }}
      </h2>
      <p class="z-10 text-xl max-w-2xl mx-auto bg-white">
          {{ t('pages.index.belief.descriptionLine1') }}<br>{{ t('pages.index.belief.descriptionLine2') }}
      </p>
      <div class="w-full mt-4">
        <div class="relative inline-block group">
          <div class="absolute inset-0 rounded bg-teal-100 border border-black transition-transform duration-150 z-20"></div>
          <div class="absolute inset-0 rounded bg-teal-100-800 border border-black transition-transform duration-150 group-hover:translate-y-2 z-10"></div>
          <NuxtLink class="relative inline-flex rounded no-underline items-center justify-center border border-black transition-all duration-150 group-hover:-translate-y-2 z-30 w-full lg:w-auto h-14 px-8 text-xl lg:h-16 lg:px-10 lg:text-xl bg-dark-teal-600 text-white" :to="localePath('features')">
            {{ t('pages.index.belief.cta') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
  <!-- Motivational Block -->
  <div class="flex flex-col border-b border-black overflow-hidden lg:flex-row">
    <div class="z-[1] bg-teal-100 flex items-center justify-center text-center lg:w-1/2 px-4 py-16 md:p-24 xl:p-32 border-b lg:border-b-0 lg:border-r">
      <div class="max-w-xl space-y-12 md:space-y-8">
        <div class="space-y-4">
          <h3 class="font-medium text-5xl lg:text-6xl text-dark-teal-600">
            <template v-for="(line, index) in motivationLeftLines" :key="`motivation-left-${index}`">
              <span>{{ line }}</span>
              <br v-if="index !== motivationLeftLines.length - 1" />
            </template>
          </h3>
        </div>
      </div>
    </div>
    <div class="z-[1] bg-teal-200 flex items-center justify-center text-center lg:w-1/2 px-4 py-16 md:p-16 xl:p-32">
      <div class="max-w-xl space-y-12 md:space-y-8">
        <div class="space-y-4">
          <h3 class="font-medium text-5xl lg:text-6xl text-dark-teal-600">
            <span>{{ motivationRightTitle.prefix }} </span>
            <em class="italic">{{ ' ' + motivationRightTitle.highlight }}</em>
            <span>{{ motivationRightTitle.suffix }}</span>
          </h3>
        </div>
      </div>
    </div>
  </div>
  <!-- Illustration Block -->
  <div class="flex flex-col border-black overflow-hidden lg:flex-row border-b overflow-visible">
    <div class="z-[1] bg-dark-teal-900 py-24 p-8 border-b sm:p-32 md:p-32 lg:py-24 lg:w-1/2 lg:border-b-0 lg:border-r xl:p-36 flex items-center justify-center">
      <div class="relative w-full max-w-xl">
        <img alt="Sell anywhere feature illustration" class="rounded-full overflow-hidden w-full h-auto object-cover mx-auto" data-parallax="true" :src="cdnImage('/images/sad-pic-woman.jpg')" width="348" height="348" />
        <div class="absolute top-[-4rem] left-0 sm:left-[-4rem] bg-white rounded-3xl px-6 sm:px-12 py-4 sm:py-8 border border-black">
            <p class="text-xl font-medium m-0">
              {{ t('pages.index.illustration.leftCaptionPrefix') }}
              <Typewriter :words="heroTypewriterWords" :typingSpeed="230" :deletingSpeed="80" :delay="6000" />
              {{ t('pages.index.illustration.leftCaptionSuffix') }}
            </p>
        </div>
      </div>
    </div>
    <div class="z-[1] bg-teal-100 py-24 p-8 flex items-center justify-center sm:p-32 md:p-16 lg:py-24 lg:w-1/2 xl:p-32">
      <div class="relative">
        <img alt="Sell anywhere feature illustration" class="w-full h-auto object-cover mx-auto border border-black" data-parallax="true" :src="cdnImage('/images/happy-pic-woman.jpg')" width="348" height="348" />
        <div class="absolute top-[-4rem] left-0 sm:left-[-4rem] bg-white rounded-3xl px-6 sm:px-12 py-4 sm:py-8 border border-black">
            <p class="text-xl font-medium m-0">{{ t('pages.index.illustration.rightCaption') }}</p>
        </div>
        <img loading="lazy" alt="Exciting sticker" class="z-[2] absolute bottom-[-4rem] sm:bottom-[-12rem] right-[0rem] sm:right-[-10rem] lg:right-[-4rem] w-36 sm:w-48 md:w-56 xl:w-80 transform rotate-6 z-10" src="https://assets.gumroad.com/assets/about/exciting-14f6b9e693b92992ec5257630887809a9c9dab2fe98c04fc53bd053bcdd09c14.svg" />
      </div>
    </div>
  </div>

  <!-- Make your own road -->
  <div class="pt-20 pb-24 border-b border-black bg-white text-black z-[1] relative">
      <div class="px-8 lg:px-[4vw]">
          <div class="flex flex-col justify-center items-center text-center gap-10 text-dark-teal-600">
                <h2 class="font-medium text-5xl lg:text-7xl">{{ t('pages.index.mission.title') }}</h2>
              <div class="text-xl max-w-2xl lg:text-3xl flex flex-col gap-4">
                <p v-for="(paragraph, index) in missionParagraphs" :key="`mission-paragraph-${index}`" class="m-0">
                  {{ paragraph }}
                </p>
              </div>
              <div class="w-full mt-4">
                  <div class="relative inline-block group">
                    <div class="absolute inset-0 rounded bg-teal-100 border border-black transition-transform duration-150 z-20"></div>
                    <div class="absolute inset-0 rounded bg-teal-100-800 border border-black transition-transform duration-150 group-hover:translate-y-2 z-10"></div>
                    <NuxtLink class="relative inline-flex rounded no-underline items-center justify-center border border-black transition-all duration-150 group-hover:-translate-y-2 z-30 w-full lg:w-auto h-14 px-8 text-xl lg:h-16 lg:px-10 lg:text-xl bg-dark-teal-600 text-white" :to="localePath('features')">
                      {{ t('pages.index.mission.cta') }}
                    </NuxtLink>
                  </div>
              </div>
          </div>
      </div>
  </div>

  <!-- Sell anything -->
  <div class="flex flex-col border-t border-black overflow-hidden lg:flex-row">
    <div class="bg-green h-auto lg:w-1/2 overflow-hidden">
      <div class="relative">
          <!-- <img alt="Sell anything feature illustration" class="w-full h-auto " data-parallax="true" src="/images/broken-mess.jpeg" /> -->
          <SmartImage alt="Sell anything feature illustration" class="h-auto ml-auto" data-parallax="true" src="/images/packaging.jpg" />
      </div>
    </div>
    <div class="z-[1] bg-light-pink-200 py-16 px-8 flex items-center justify-center sm:p-12 md:p-16 lg:w-1/2 xl:p-24">
      <div class="max-w-2xl space-y-12 md:space-y-8 text-dark-teal-600">
        <div class="space-y-4">
          <h3 class="font-medium text-3xl lg:text-4xl xl:text-5xl">
              {{ t('pages.index.sell.title') }}
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">
              {{ t('pages.index.sell.description') }}
          </p>
        </div>
        <ul class="grid grid-cols-1 gap-3 pl-0 text-lg md:grid-cols-2">
          <li v-for="item in sellItems" :key="item" class="flex items-center">
            <span class="mr-2">→</span>
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Steph Smith testimonial block: place here, before the income banner -->
  <div class="flex flex-col border-t border-black bg-pink py-16 lg:flex-row">
    <div class="z-[1] bg-white px-8 text-left mx-auto flex items-center justify-end order-2 md:px-24 md:text-center lg:w-1/2 lg:text-left lg:order-1">
      <div class="max-w-xl grid !gap-y-10 md:max-w-2xl lg:max-w-3xl">
        <h2 class="text-2xl md:text-3xl lg:text-4xl">
          {{ t('pages.index.testimonialMargherita.quote') }}
        </h2>
        <div class="text-xl font-bold">
          {{ t('pages.index.testimonialMargherita.author') }}
        </div>
      </div>
    </div>
    <div class="z-[1] w-full flex items-center justify-center h-full min-h-[22rem] p-[6.5vw] order-1 lg:w-1/2 lg:order-2">
      <div class="relative flex flex-col items-center justify-center">
        <SmartImage alt="Jane Doe portrait" class="w-full max-w-[36rem] h-full object-contain transform -translate-y-4 transition-transform duration-500" src="/images/index/janedoe.png" />
        <img alt="Dollar symbol illustration" class="absolute w-16 top-8 left-0 parallax-up sm:w-24 md:top-10 md:left-12" src="https://assets.gumroad.com/assets/about/dollar-ee4bbf21c21fcb781d58a4366e9afcc401cdaf99a9b9a702cd3cd29c7a2fdc06.svg" />
        <SmartImage alt="Decorative colors illustration" class="absolute w-36 -bottom-4 -right-8 parallax-up sm:w-64 md:-bottom-8 md:-right-12" src="/images/index/nice.png" />
        <!-- <img alt="Decorative colors illustration" class="absolute w-36 -bottom-4 -right-8 parallax-up sm:w-64 md:-bottom-8 md:-right-12" src="https://assets.gumroad.com/assets/about/nice.svg" /> -->
        <a
          href="/of/cassie-oconnor"
          class="absolute flex items-center gap-2 bg-white pl-1 pr-3 py-1 rounded-full border border-black no-underline transition-all duration-200 ease-in-out hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[3px_3px_#000] bottom-8 -left-2 sm:bottom-24 sm:left-12 md:left-8 lg:-left-4"
        >
          <img alt="Gumroad icon" class="w-9 h-9 rounded-full" src="https://leokongwq.github.io/img/avatar.png" />
          <span class="text-lg font-medium">Margherita - cassie-oconnor</span>
        </a>
      </div>
    </div>
  </div>


  <div class="flex flex-col border-t border-black overflow-hidden lg:flex-row">
    <div class="bg-dark-teal-600 py-24 p-8 border-b sm:p-12 md:p-16 lg:w-1/2 lg:border-b-0 lg:border-r xl:p-32">
      <div class="relative">
        <SmartImage alt="Sell to anyone feature illustration" class="w-full h-auto" data-parallax="true" src="/images/index/ppp.png" />
      </div>
    </div>
    <div class="z-[1] bg-teal-200 py-16 p-8 flex items-center justify-center sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
      <div class="max-w-2xl space-y-12 md:space-y-8 text-dark-teal-600">
        <div class="space-y-4">
          <h3 class="font-medium text-3xl lg:text-4xl xl:text-5xl">
            {{ t('pages.index.pricingFeature.title') }}
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">
            <span>{{ pricingFeatureDescriptionSegments.prefix }} </span>
            <strong class="font-semibold">{{ ' ' + pricingFeatureDescriptionSegments.highlight + '. '}}</strong>
            <span> {{ pricingFeatureDescriptionSegments.suffix }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-col border-t border-black bg-green py-16 lg:flex-row">
    <div class="z-[1] bg-white px-8 text-left mx-auto flex items-center justify-end order-2 md:px-24 md:text-center lg:w-1/2 lg:text-left lg:order-1">
      <div class="max-w-xl grid !gap-y-10 md:max-w-2xl lg:max-w-3xl">
        <div class="text-2xl md:text-3xl lg:text-4xl flex flex-col gap-6">
          <p v-for="(paragraph, index) in founderQuoteParagraphs" :key="`founder-quote-${index}`" class="m-0">
            {{ paragraph }}
          </p>
        </div>
        <div class="text-xl font-bold">
          {{ founderAuthorData.name }} -
          <span class="font-thin font-serif">{{ founderAuthorData.brand }}</span>
        </div>
      </div>
    </div>
    <div class="relative z-[1] w-full flex items-center justify-center h-full min-h-[22rem] order-1 xl:w-4/5 lg:w-2/3 lg:order-2">
      <div class="flex flex-col items-center justify-center">
        <img alt="Dru Riley portrait" class="w-full max-w-full h-full object-contain transform -translate-y-4 transition-transform duration-500" src="/images/giorgia-barca.jpg" />
        <!-- <img alt="Free illustration" class="absolute w-36 -top-4 -right-4 parallax-up sm:w-48 md:w-64 md:-top-8 md:-right-8" src="https://assets.gumroad.com/assets/about/free-9a61d2a84738e0d71eecd831151d5b898baec7d493113ea7f23dec6844939288.svg" />
        <img alt="Book illustration" class="absolute w-36 -bottom-4 -left-4 parallax-up sm:w-48 md:w-64 md:-bottom-8 md:-left-32" src="https://assets.gumroad.com/assets/about/book-f34b91dab2e57ce4b20c7d8e806022791fe8bf902014a29f9f22532a16d5c5b6.svg" /> -->
        <NuxtLink
          :to="localePath('about')"
          class="max-w-[32rem] absolute flex items-center gap-2 bg-white pl-1 pr-3 py-1 rounded-full border border-black no-underline transition-all duration-200 ease-in-out hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[3px_3px_#000] bottom-8 sm:bottom-24 sm:left-12 md:left-8 lg:-left-4"
        >
          <img alt="Gumroad icon" class="w-9 h-9" src="/images/giorgia.png" />
          <span class="block text-lg font-medium">{{ t('pages.index.founder.badge') }}</span>
        </NuxtLink>
      </div>
    </div>
  </div>

  <!-- <div class="flex flex-col border-t border-black overflow-hidden lg:flex-row">
    <div class="bg-orange py-24 p-8 border-b sm:p-12 md:p-16 lg:py-24 xl:py-16 lg:w-1/2 lg:border-b-0 lg:border-r xl:p-32">
      <div class="relative">
        <img alt="Sell anywhere feature illustration" class="w-full h-auto" data-parallax="true" src="https://assets.gumroad.com/assets/about/home-feature-4-8918fc7bd5e92e4f38f7fc7c6d660afb7eace4be0fae2111d3f7a351ce7c3b70.svg" />
      </div>
    </div>
    <div class="bg-white py-16 p-8 flex items-center justify-center sm:p-12 md:p-16 lg:w-1/2 xl:p-32">
      <div class="max-w-2xl space-y-12 md:space-y-8">
        <div class="space-y-4">
          <h3 class="font-medium text-3xl lg:text-4xl xl:text-5xl">
            òmmi òmmi...
          </h3>
          <p class="text-lg lg:text-xl xl:text-2xl">            
            "ommi" is a spontaneous exclamation used in moments of danger, discomfort, or surprise. It’s similar to saying “oh no” or “oh dear,” but carries an even deeper emotional punch.<br>
            People say “òmmi òmmi” when something is about to go wrong — when you stumble, or when something breaks.<br>
            It’s precisely that moment of imbalance and imperfection that inspired the birth of my little shop of errors.<br>
          </p>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Collection Navigation -->
  <CollectionNavigation 
    :current-collection="1" 
    @navigate="handleCollectionNavigate" 
  />

    <!-- Collection Section -->
    <CollectionSection :collection-id="1" />


  <div class="z-[1] block text-black font-['Inter'] text-base font-normal leading-relaxed tracking-tight">

    <!-- Countdown Timer Section -->
  <CountdownTimer :message="t('pages.index.countdown.message')" />

    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n, useLocalePath } from '#imports'
import { useSeo } from '~/composables/useSeo'

import ParallaxCoin from '~/components/ParallaxCoin.vue'
import Typewriter from '~/components/common/Typewriter.vue'

type HeroTagline = {
  line1: string
  line2: string
}

type IndexMeta = {
  title: string
  description: string
  keywords: string
  author: string
  language: string
  ogLocale: string
  ogImageAlt: string
  twitterSite: string
  twitterCreator: string
  canonicalUrl: string
}

type MotivationLeftTitle = {
  lines: string[]
}

type MotivationRightTitle = {
  prefix: string
  highlight: string
  suffix: string
}

type MissionDescription = {
  paragraphs: string[]
}

type PricingFeatureDescription = {
  prefix: string
  highlight: string
  suffix: string
}

type FounderQuote = {
  paragraphs: string[]
  brand?: string
}

type FounderAuthor = {
  name: string
  brand: string
}

const ensureString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value
  }
  if (value == null) {
    return ''
  }
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value)
  }
  try {
    return String(value)
  } catch {
    return ''
  }
}

const ensureStringArray = (value: unknown): string[] => {
  if (!Array.isArray(value)) {
    return []
  }
  return value.map(ensureString).filter((entry) => entry.length > 0)
}

const { t, tm, locale, messages, fallbackLocale } = useI18n()
const localePath = useLocalePath()

const getLocaleMeta = (localeCode: string | undefined): Record<string, unknown> | undefined => {
  if (!localeCode || typeof localeCode !== 'string') {
    return undefined
  }
  const localeMessages = messages.value?.[localeCode as keyof typeof messages.value] as Record<string, any> | undefined
  return localeMessages?.pages?.index?.meta
}

const fallbackLocales = computed<string[]>(() => {
  const raw = fallbackLocale.value
  if (typeof raw === 'string') {
    return [raw]
  }
  if (Array.isArray(raw)) {
    return (raw as unknown[]).filter((entry): entry is string => typeof entry === 'string')
  }
  if (raw && typeof raw === 'object') {
    return Object.values(raw as Record<string, unknown>).filter(
      (entry): entry is string => typeof entry === 'string'
    )
  }
  return []
})

const buildMetaSource = (): Record<string, unknown> | undefined => {
  const primary = tm('pages.index.meta') as Record<string, unknown> | undefined
  if (primary && typeof primary === 'object') {
    return primary
  }

  const localesToTry = new Set<string>()
  if (typeof locale.value === 'string') {
    localesToTry.add(locale.value)
  }
  fallbackLocales.value.forEach((entry) => localesToTry.add(entry))
  localesToTry.add('en')

  for (const candidateLocale of localesToTry) {
    const candidate = getLocaleMeta(candidateLocale)
    if (candidate && typeof candidate === 'object') {
      return candidate
    }
  }

  return undefined
}

const sanitizeHeadEntry = (entry: Record<string, unknown>): Record<string, string | boolean | null | undefined> => {
  const sanitized: Record<string, string | boolean | null | undefined> = {}
  Object.entries(entry).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      sanitized[key] = value as null | undefined
      return
    }
    if (typeof value === 'string' || typeof value === 'boolean') {
      sanitized[key] = value
      return
    }
    if (typeof value === 'number' || typeof value === 'bigint') {
      sanitized[key] = String(value)
      return
    }
    if (value instanceof URL) {
      sanitized[key] = value.toString()
      return
    }
    if (value instanceof Date) {
      sanitized[key] = value.toISOString()
      return
    }
    try {
      const stringValue = (value as { toString?: () => string }).toString?.()
      sanitized[key] = typeof stringValue === 'string' ? stringValue : ''
    } catch {
      sanitized[key] = ''
    }
  })
  return sanitized
}

const sanitizeHeadEntries = (entries: Array<Record<string, unknown>>): Array<Record<string, string | boolean | null | undefined>> => {
  return entries.map((entry) => sanitizeHeadEntry(entry))
}

const heroTypewriterWords = computed(() => ensureStringArray(tm('pages.index.hero.typewriterWords')))

const heroTagline = computed<HeroTagline>(() => {
  const raw = tm('pages.index.hero.tagline') as Partial<HeroTagline> | string | undefined
  return {
    line1: ensureString(typeof raw === 'object' && raw ? raw.line1 : undefined),
    line2: ensureString(typeof raw === 'object' && raw ? raw.line2 : undefined)
  }
})

const motivationLeftTitle = computed(() => tm('pages.index.motivation.leftTitle') as MotivationLeftTitle | undefined)
const motivationLeftLines = computed(() => ensureStringArray(motivationLeftTitle.value?.lines))
const motivationRightTitle = computed<MotivationRightTitle>(() => {
  const data = tm('pages.index.motivation.rightTitle') as Partial<MotivationRightTitle> | undefined
  return {
    prefix: ensureString(data?.prefix),
    highlight: ensureString(data?.highlight),
    suffix: ensureString(data?.suffix)
  }
})

const missionDescription = computed(() => tm('pages.index.mission.description') as MissionDescription | undefined)
const missionParagraphs = computed(() => ensureStringArray(missionDescription.value?.paragraphs))

const pricingFeatureDescription = computed(() => tm('pages.index.pricingFeature.description') as PricingFeatureDescription | undefined)
const pricingFeatureDescriptionSegments = computed<PricingFeatureDescription>(() => {
  const data = pricingFeatureDescription.value
  return {
    prefix: ensureString(data?.prefix),
    highlight: ensureString(data?.highlight),
    suffix: ensureString(data?.suffix)
  }
})

const founderQuote = computed(() => tm('pages.index.founder.quote') as FounderQuote | undefined)
const founderQuoteParagraphs = computed(() => {
  const quote = founderQuote.value
  const paragraphs = ensureStringArray(quote?.paragraphs)
  const brand = ensureString(quote?.brand)
  return paragraphs.map((paragraph) =>
    brand ? paragraph.replace(/\{brand\}/g, brand) : paragraph
  )
})

const founderAuthor = computed(() => tm('pages.index.founder.author') as FounderAuthor | undefined)
const founderAuthorData = computed(() => ({
  name: ensureString(founderAuthor.value?.name),
  brand: ensureString(founderAuthor.value?.brand)
}))

const sellItems = computed(() => ensureStringArray(tm('pages.index.sell.items')))
const metaContent = computed<IndexMeta>(() => {
  const raw = buildMetaSource() as Partial<IndexMeta> | undefined

  if (!raw || typeof raw !== 'object') {
    return {
      title: '',
      description: '',
      keywords: '',
      author: '',
      language: '',
      ogLocale: '',
      ogImageAlt: '',
      twitterSite: '',
      twitterCreator: '',
      canonicalUrl: ''
    }
  }

  return {
    title: ensureString(raw.title),
    description: ensureString(raw.description),
    keywords: ensureString(raw.keywords),
    author: ensureString(raw.author),
    language: ensureString(raw.language),
    ogLocale: ensureString(raw.ogLocale),
    ogImageAlt: ensureString(raw.ogImageAlt),
    twitterSite: ensureString(raw.twitterSite),
    twitterCreator: ensureString(raw.twitterCreator),
    canonicalUrl: ensureString(raw.canonicalUrl)
  }
})

// Navigation handler
const handleCollectionNavigate = (collectionId: number) => {
  console.log('Navigating to collection:', collectionId)
  // Navigation is handled in the component itself
}

// Use SEO composable for homepage
useSeo({
  title: metaContent.value.title,
  description: metaContent.value.description,
  keywords: metaContent.value.keywords,
  author: metaContent.value.author,
  image: '/ommi-shop-og-image.png',
  imageAlt: metaContent.value.ogImageAlt,
  canonicalUrl: metaContent.value.canonicalUrl,
  type: 'website'
})
</script>